export const SuccessMessageConst = {
  ItemDeletedSuccessfully: 'Servicio eliminado exitosamente',
  ItemAddedSuccessfully: 'Servicio agregado exitosamente',
  DomainAddedSuccessfully: 'Dominio agregado exitosamente',
  ContactAddedSuccessfully: "La información del contacto se almacenó exitosamente",
  LoginSuccess: "Sesión iniciada exitosamente.",
  AccountCreated: "Cuenta creada exitosamente."
};
